import { render, staticRenderFns } from "./ListLoading.vue?vue&type=template&id=1ca27560"
var script = {}
import style0 from "./ListLoading.vue?vue&type=style&index=0&id=1ca27560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports